export enum POSScreens {
  RESTAURANT_DETAIL = "RestaurantDetail",
  CONFIRMATION_PAGE = "ConfirmationPage",
  EDENRED_CALLBACK = "EdenredCallback",
}
